<button (click)="toggleClick(!currentState)" title="click to change to {{(!currentState)}}" type="button">
    {{ (currentState) }}
</button>
